import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-services',
  imports: [],
  templateUrl: './services.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './services.scss',
})
export class Services {

}
